import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableSortLabel,
  IconButton,
  Grid,
  Button,
} from '@material-ui/core'
import moment from 'moment'
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons'
import { mdiPencil } from '@mdi/js'
import { useDispatch, useSelector } from 'react-redux'

import { Creators as EquipmentsTypesActions } from '~/store/ducks/equipmentsTypes'
import { Creators as EquipmentTypeActions } from '~/store/ducks/equipmentType'

import Portlet from '~/components/Portlet'
import ListFooter from '~/components/ListFooter'
import CustomIcon from '~/components/CustomIcon'
import { useSmallScreen } from '~/helpers/useMediaQuery'
import OverlayLoading from '~/components/OverlayLoading'
import ConfirmDialog from '~/components/ConfirmDialog'
import SearchInput from '~/components/SearchInput'
import EmptyList from '~/components/EmptyList'
import DialogEquipmentsTypes from './components/DialogEquipmentsTypes'

import styles from './style'

const equipmentsTypesSelector = (state) => state.equipmentsTypes

const useStyles = makeStyles(styles)

function EquipmentsTypesPage() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const equipamentsTypes = useSelector(equipmentsTypesSelector)
  const { data: equipmentsTypes, options, loading } = equipamentsTypes
  const { sort, direction } = options
  const [equipmentTypeId, setEquipmentTypeId] = useState(null)
  const [openDialog, setOpenDialog] = useState(false)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const isSmallScreen = useSmallScreen()

  useEffect(() => {
    dispatch(EquipmentsTypesActions.getEquipmentsTypesRequest())
    return () => {
      dispatch(EquipmentsTypesActions.resetEquipmentsTypes())
    }
  }, [])

  const handleSortChange = (newSort) => {
    const isSameSort = newSort === sort
    let sortDirection = direction

    if (isSameSort) {
      if (direction === 'asc') {
        sortDirection = 'desc'
      } else {
        sortDirection = 'asc'
      }
    }

    dispatch(
      EquipmentsTypesActions.setEquipmentsTypesSort(newSort, sortDirection),
    )
  }

  const handleChangeRowsPerPage = (ev) => {
    const {
      target: { value },
    } = ev
    dispatch(EquipmentsTypesActions.setEquipmentsTypesPage(0, value))
  }

  const handleChangePage = (ev, page) => {
    dispatch(EquipmentsTypesActions.setEquipmentsTypesPage(page, options.limit))
  }

  const handleEditEquipmentsTypes = (id) => {
    setEquipmentTypeId(id)
    setOpenDialog(true)
  }

  const handleAddEquipmentsTypes = () => {
    setOpenDialog(true)
  }

  const handleClose = () => {
    setOpenDialog(false)
    setEquipmentTypeId(null)
  }

  const handleRemoveEquipmentType = (id) => {
    setEquipmentTypeId(id)
    setOpenConfirmDialog(true)
  }

  const handleRemoveCancel = () => {
    setEquipmentTypeId(null)
    setOpenConfirmDialog(false)
  }

  const handleRemoveAccept = () => {
    dispatch(
      EquipmentTypeActions.removeEquipmentTypeRequest(equipmentTypeId, () => {
        dispatch(EquipmentsTypesActions.getEquipmentsTypesRequest())
        setEquipmentTypeId(null)
        setOpenConfirmDialog(false)
      }),
    )
  }
  const handleSearchChange = (value) => {
    dispatch(EquipmentsTypesActions.setEquipmentsTypesSearch(value))
  }
  return (
    <div className={classes.root}>
      <Grid
        container
        justifyContent="space-between"
        className={classes.gridContainerButton}
      >
        <Grid item xs={12} md={6}>
          <SearchInput
            onChange={(e) => handleSearchChange(e.target.value)}
            placeholder="Pesquise por descrição..."
          />
        </Grid>
        <Grid item style={{ paddingTop: isSmallScreen ? 8 : '' }}>
          <Button
            variant="contained"
            color="primary"
            className={classes.buttonAdd}
            onClick={handleAddEquipmentsTypes}
          >
            <AddIcon className={classes.iconAdd} /> Adicionar Tipo de
            equipamento
          </Button>
        </Grid>
      </Grid>
      <Portlet className={classes.grow}>
        <div className={classes.tableWrapper}>
          {!loading && equipmentsTypes.length === 0 && (
            <EmptyList message="Não há tipos de equipamentos para serem visualizados" />
          )}
          {loading && <OverlayLoading />}
          {!loading && (
            <div className={classes.listWrapper}>
              {equipmentsTypes.length > 0 && (
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <TableSortLabel
                          active={sort === 'name'}
                          onClick={() => handleSortChange('name')}
                          direction={direction}
                        >
                          Descrição
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={sort === 'created_at'}
                          onClick={() => handleSortChange('created_at')}
                          direction={direction}
                        >
                          Data de Cadastro
                        </TableSortLabel>
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {equipmentsTypes.map((equipmentType) => (
                      <TableRow
                        hover
                        key={equipmentType.id}
                        className={classes.tableRow}
                      >
                        <TableCell>{equipmentType.name || '-'}</TableCell>
                        <TableCell>
                          {moment(equipmentType.created_at || '-').format(
                            'DD/MM/YYYY HH:mm',
                            'HH/MM',
                          )}
                        </TableCell>
                        <TableCell align="right">
                          <div className={classes.tableCellActions}>
                            <IconButton
                              className={classes.editIcon}
                              onClick={() =>
                                handleEditEquipmentsTypes(equipmentType.id)
                              }
                            >
                              <CustomIcon pathComponent={mdiPencil} />
                            </IconButton>
                            <IconButton
                              className={classes.iconButton}
                              onClick={() =>
                                handleRemoveEquipmentType(equipmentType.id)
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </div>
          )}
        </div>

        {!loading && equipmentsTypes.length > 0 && (
          <ListFooter
            options={options}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            onChangePage={handleChangePage}
          />
        )}
      </Portlet>

      <DialogEquipmentsTypes
        open={openDialog}
        onClose={handleClose}
        id={equipmentTypeId}
      />
      <ConfirmDialog
        open={openConfirmDialog}
        title="Atenção"
        description="Deseja realmente excluir este tipo de equipamento?"
        onCancel={handleRemoveCancel}
        onAccept={handleRemoveAccept}
      />
    </div>
  )
}
export default EquipmentsTypesPage
